import React from 'react';
import { Select as AntSelect } from 'antd';

const { Option } = AntSelect;

interface ISelectOptionProps {
  children?: React.ReactNode;
}

// TODO move as compound component Select.Option
const SelectOption = function ({ children }: ISelectOptionProps): JSX.Element {
  return <Option>{children}</Option>;
};

export { SelectOption };
